import { render, staticRenderFns } from "./PrivateRelayWarningDialog.vue?vue&type=template&id=37b23864&scoped=true"
import script from "./PrivateRelayWarningDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivateRelayWarningDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=0&id=37b23864&prod&scoped=true&lang=css"
import style1 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=1&id=37b23864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b23864",
  null
  
)

export default component.exports